module.exports = __webpack_public_path__ + "img/custom.f5b3d17e.svg";